/**
 * Calendario (input element)
 */
export const inputDatePicker = document.getElementById("daterange");

/**
 * Boton para la busqueda de pedimentos de exportación
 */
export const btnBuscarPedimentos = document.getElementById("boton_obtener_informacion");

/**
 * Botón para manejar la obteneción de pedimentos importación o simular la descarga
 */
export const btnDescarga = document.getElementById("descargar");

/**
 * Botón pasa al siguiente material
 */
export const btnSiguienteMaterial = document.getElementById("btn-siguiente-material");

/**
 * Botón para cancelar la descarga
 */
export const btnCancelaDescargo = document.getElementById("btn-cancela-descargo");
